//export const SERVER_BASE_URL = 'http://localhost:3000'

export const SERVER_BASE_URL = 'https://home-seek.herokuapp.com'
export const GOOGLE_CLIENT_ID = '313745394079-k2uv8ome8c5e1moh2231dc9nd7o33fa1.apps.googleusercontent.com'
export const FACEBOOK_APP_ID = '323846888789404'
export const API_KEY = 'AIzaSyC0rTgUMIqtPBfwM7oFkvQZ3ZAskgTX0F4'